<template>
  <el-form
    ref="loginByPassword"
    status-icon
    :model="loginForm"
    :rules="loginRules"
    class="login-form"
    autocomplete="on"
    label-position="left"
  >
    <el-form-item prop="phoneNumber">
      <el-input
        ref="username"
        v-model="loginForm.phoneNumber"
        placeholder="请输入手机号码"
        name="username"
        type="text"
        tabindex="1"
        autocomplete="on"
      >
        <template slot="prepend">
          <svg-icon icon-class="user" />
        </template>
      </el-input>
    </el-form-item>

    <el-form-item prop="password">
      <el-input
        :key="passwordType"
        ref="password"
        v-model="loginForm.password"
        :type="passwordType"
        placeholder="输入 6 ~ 20 位数字和字母组合密码"
        name="password"
        tabindex="2"
        @keyup.enter.native="verifyLoginForm('loginByPassword')"
      >
        <template slot="prepend">
          <svg-icon icon-class="password" />
        </template>
        <span slot="suffix" @click="showPwd" class="show-pwd">
          <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
        </span>
      </el-input>
    </el-form-item>

    <el-form-item>
      <el-checkbox v-model="loginForm.rememberMe">记住密码</el-checkbox>
    </el-form-item>

    <el-button
      type="primary"
      class="login-button"
      @click.native.prevent="verifyLoginForm('loginByPassword')"
    >登录</el-button>
  </el-form>
</template>

<script>
import mixin from "./mixin";
import { pbkdf2Hash } from "@/utils/cryptoUtil.js";
export default {
  mixins: [mixin],

  data() {
    return {
      capsTooltip: true,
      passwordType: "password"
    };
  },

  computed: {
    passwordRules() {
      return this.loginRules;
    }
  },

  methods: {
    async handleLogin() {
      const password = await pbkdf2Hash(
        this.loginForm.password,
        this.loginForm.phoneNumber
      );

      const loginData = {
        phoneNum: this.loginForm.phoneNumber,
        passwd: password
      };

      await this.$api.loginByPassword(loginData, this.loginForm.rememberMe);

      this.loginSuccess();
    },

    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-form {
  .show-pwd {
    position: absolute;
    right: 30px;
    top: 11px;
    font-size: 18px;
    cursor: pointer;
    user-select: none;
  }

  .login-button {
    width: 100%;
    margin-bottom: 25px;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 25px;
  }
}
</style>


